import React from "react";
import { ContentContainer } from "../../../components/layout";
import { CSVLink } from "react-csv";
import {
	Button,
	DateRangePicker,
	MultiSelectTable,
	Select,
} from "../../../components/core";

export default function ReassignPackage() {
	return (
		<ContentContainer containerTitle={"REASSIGN PACKAGES"}>
			<div className="grid grid-cols-5 gap-2 w-full mb-2 ml-4">
				<div className="col-span-1">
					<p className="text-base mt-2">Locker:</p>
				</div>
				<div className="col-span-2">
					<Select
						name="lockerId"
						// items={lockerList}
						// defaultOption={{
						// 	value: "-1",
						// 	name: "-- Select a locker --",
						// }}
						// onChange={handleChangeSearchCriteria}
					/>
				</div>
				<div className="col-span-2"></div>
				<div className="col-span-1">
					<p className="text-base mt-2">Package State:</p>
				</div>
				<div className="col-span-2">
					<Select
						name="packageStateNo"
						// items={[
						// 	{ value: "140", name: "For Pull-Out" },
						// 	{ value: "130", name: "For Take-Back" },
						// ]}
						// defaultOption={{ value: "-1", name: "-- All --" }}
						// onChange={handleChangeSearchCriteria}
					/>
				</div>
				<div className="col-span-1"></div>
				<div className="col-span-3">
					<DateRangePicker
						startDateName="startDate"
						endDateName="endDate"
						// onChange={handleChangeSearchCriteria}
						// startDate={searchCriteria.startDate}
						// endDate={searchCriteria.endDate}
					/>
				</div>
				<div>
					<Button
						className={"p-2"}
						value="Search"
						// onClick={handleSearchLockerCleanUpData}
					/>
				</div>
			</div>
			<>
				<div className="bg-primary-primaryYellow w-full border-stone-400 border-b-2 text-center pt-2">
					<p className="font-bold text-lg m-auto p-2">
						{/* {searchResultSentence} */}
					</p>
					<div className="flex">
						{/* <button className="p-2 bg-green-600 font-bold text-white rounded-md m-2 ml-auto">
							<CSVLink
								// data={lockerCleanupData}
								filename="cleanup-report"
							>
								Download CSV
							</CSVLink>
						</button> */}
						{/* <button
							className="p-2 bg-green-600 font-bold text-white rounded-md m-2"
							// onClick={downloadExcel}
						>
							Download Excel
						</button> */}
					</div>
				</div>
				<MultiSelectTable
					id={"cleanup-table"}
					items={[]}
					headers={{
						partnerAgentMobile: "Courier Mobile Number",
						recipientMobile: "Recipient Mobile Number",
						packageDate: "Package Date",
						waybillNumber: "Waybill",
						packageStateNo: "Package State",
						lockerLocation: "Locker Location",
					}}
					keyToSelect="packageId"
					// setSelectedData={setSelectedData}
				/>
				<div className="w-full flex justify-centers">
					<Button
						value={"SEND PULLOUT CODE TO MAINTENANCE"}
						className={"p-2 mx-auto my-4"}
						// onClick={() => setOpenPulloutCode(true)}
					/>
				</div>
			</>
		</ContentContainer>
	);
}
